import React from 'react'
import { Container, Divider, Header, Image } from 'semantic-ui-react'

const HeaderTitulo = () => (
  <Container>
    <Divider hidden />

    <Header size="large" textAlign="center">
      <Image circular size="large" src="/assets/images/foto.jpeg" /> 
      <Header.Content>
        Gustavo Santos
      </Header.Content>
    </Header>

    <Divider hidden />
  </Container>
)

export default HeaderTitulo


// WEBPACK FOOTER //
// ./src/components/HeaderTitulo.js